import React,{Component} from "react";
import {
  NavBar,
  Icon,
  List,
  Toast,
  Button,
  Checkbox
} from 'antd-mobile'
import './prefixInfo.scss'
import axios from "../../../service/axios";
const Item = List.Item;
const CheckboxItem = Checkbox.CheckboxItem;

export class PrefixInfo extends Component{
  state = {
    dataSource: {},
    isLoading: true,
    isAllChecked: false,
    groupDatas: [],
    selectData:[],
    userGroups: []
  }
  componentWillMount(){
    var pathname = this.props.location.pathname.split('prefixInfo/')[1];
    console.log(pathname)
    this.setState({
      prefixname: pathname.split('/')[0],
      iccid: pathname.split('/')[1]
    },()=>{
      console.log('info',this.state.prefixname,this.state.iccid)
      this.getGruopList();
    })
  }
  // 获取前缀下的群组列表
  getGruopList(){
    axios.post('/api/group/prefixname/list/detail',{"prefixName":this.state.prefixname})
    .then(res=>{
      console.log('list',res)
      if(res.status==200){
        this.setState({
          groupDatas:res.data
        },()=>{
          this.getUserIsIngroup()
        })
      }
    })
  }
  // 获取用户所在的所有群组
  getUserIsIngroup(){
    // axios.post('/api/group/list/relation/iccids',{'iccids': '11111222223333344444'})
    axios.post('/api/group/list/relation/iccids',{'iccids': this.state.iccid})
    .then(res => {
      console.log('selectData',res)
      console.log(JSON.stringify(res.data)=='{}')
      if(res.status==200 && JSON.stringify(res.data)!='{}'){
        this.setState({
          selectData: res.data[this.state.iccid]
        },()=>{
          // 获取用户所在的当前前缀的群组
          let groupDatas=  this.state.groupDatas;
          var arr = new Array();
          for(var i=0;i<groupDatas.length;i++){
            for(var j=0;j<this.state.selectData.length;j++){
              if(this.state.selectData[j]==groupDatas[i].gid){
                arr.push(groupDatas[i])
                groupDatas[i].checked = true;
              }
            }
          }
          if(arr.length==groupDatas.length){
            this.setState({
              isAllChecked:true
            })
          }
          else{
            this.setState({
              isAllChecked:false
            })
          }
          this.setState({
            groupDatas
          })
        })
      }else{
        console.log(res)
        this.setState({
          selectData:[]
        })
        Toast.fail('加载失败')
      }
    })
  }

  onChange = (e, item, index) => {
    let groupDatas = this.state.groupDatas;
    for(var i=0; i<groupDatas.length; i++){
      if(i==index){
        groupDatas[i].checked = e.target.checked;
      }
    }
    var arr = new Array();
    for(var i = 0;i<groupDatas.length;i++){
      if(groupDatas[i].checked){
        arr.push(groupDatas[i])
      }
    }
    if(arr.length==groupDatas.length){
      this.setState({
        isAllChecked:true
      })
    }
    else{
      this.setState({
        isAllChecked:false
      })
    }
    this.setState({
      groupDatas:groupDatas
    })
  };
  allCheckMonth=(e)=>{
    const idChecked = e.target.checked;
    this.setState({
      isAllChecked:idChecked
    })
    let groupDatas = this.state.groupDatas;
    for(var i = 0;i < groupDatas.length; i++){
      groupDatas[i].checked = idChecked;
    }
    this.setState({
      groupDatas
    })
  }
  // 提交修改用户群组
  confirm(){
    // 获取当前页面勾选了的Item的gid
    let groupDatas =  this.state.groupDatas;
    let arr = new Array();
    for(var i=0;i<groupDatas.length;i++){
      if(groupDatas[i].checked){
        arr.push(groupDatas[i].gid)
      }
    }
    if(arr.length==0){
      Toast.fail('请选至少选择一个群组！', 1);
      return;
    }
    axios.post("/api/group/prefixname/members/batch/relation", {
    // axios.post("/api/group/members/batch2/scan", {
      gids: arr,
      iccid: this.state.iccid,
      prefixName: this.state.prefixname
    })
    .then(res => {
      if (res.status == 200) {
        Toast.success('提交成功！', 1,()=>{
          console.log(res.message)
          this.props.history.push('/menu')
        });
      }
      else{
        Toast.fail(res.message, 1);
      }
    })
  }
  row = (data)=>{
   return( data.map((val,key)=>{
      return(
        <div key={key}>
          <CheckboxItem
            checked={val.checked?true:false}
            onChange={e => this.onChange(e, val, key)}
          >
            {val.name}
          </CheckboxItem>
        </div>
      )
    }))
  }
  render(){
    const {
      isLoading,
      isAllChecked,
      groupDatas
    } = this.state
    return (
      <div className="prefixInfo">
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left" />}
            onLeftClick={() => this.props.history.goBack()}
          >
            选择群组
          </NavBar>
        </div>
        <div className="prefixList">
          <List>
            <CheckboxItem
              checked={this.state.isAllChecked?true:false}
              onChange={(e)=>{this.allCheckMonth(e)}}
            >
              全选
            </CheckboxItem>
            {this.row(groupDatas)}
          </List>
          <Button 
            type="primary" 
            style={{
              width:'200px',
              margin:'0 auto',
              height:'40px',
              lineHeight:'40px',
              marginBottom:'5px',
              marginTop:'10px'
            }}
            onClick={this.confirm = this.confirm.bind(this)}
            >
              确认
            </Button>
          <Button 
            type="primary" 
            style={{
              width:'200px',
              margin:'0 auto',
              height:'40px',
              lineHeight:'40px',
              marginBottom:'5px',
              marginTop:'10px'
            }}
            onClick={() => this.props.history.goBack()}
            >
              返回
            </Button>
        </div>
        
        {/* 最多三十条数据,不需要分页 */}
      </div>
    )
  }
}

export default PrefixInfo